import React from "react";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import rightImg from "images/about-hero-right.png";
import SectionHero from "components/SectionHero/SectionHero";
import Layout from "../../(others)/layout"
import "../../../styles/styles.css"

const PageMission = () => {
  return (
    <Layout>
      <div className="dark bg-neutral-900/95 text-white  py-4 lg:py-7 space-y-4 lg:space-y-7">
         <div className={`nc-PageAbout relative`}>
         <div className={`nc-SectionHero relative `}>

            <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
              <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
                <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">
                  Permis
                </h2>
                <span  className="marge block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                  <ul  className="circle">
                    <li>Certificat de Pilote</li>
                    <li>Immatriculation</li>
                    <li>Autorisation de vol</li>
                  </ul>
                </span>
              </div>
          
              <div className="center">
                <table style={{width:"100%"}} className="center ">
                    <tbody></tbody>
                    <tr>
                      <td style={{width:"33%"}}>
                        <img className="permis" src="../../images/CertificatPilote.jpg" />
                      </td>
                      <td style={{width:"33%"}}>
                        <img className="permis" src="../../images/Immatriculation.jpg" />
                      </td>
                      <td style={{width:"33%"}}>
                        <img className="permis" src="../../images/Autorisation.jpg" />
                      </td>
                    </tr>
                  </table> 
                </div> 
              </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PageMission;
